export default __webpack_public_path__ + "static/media/kausi1-min.da7a59ae.jpg";